<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Breadcrumbs main="Verra Reports" title="default" />
  <div class="container-fluid p-0">
    <div class="row widget-grid">
      <!-- <Filter
        :stateProp="stateList"
        @filterHandle="filterHandle"
        :hasCustomDate="true"
        :hasCustomer="false"
        :hasPeriod="false"
        :periodNameProp="`Current MP`"
        :applyMPs="true"
      /> -->

      <div class="row widget-grid m-0 mt-2 p-0">
        <div class="m-0 py-0">
          <el-row>
            <el-col :span="filterButtonOpenClose || $vuetify.display.width < 450 ? 24 : 8">
              <div class="pl-0">
                <FilterS2
                  :period-name-prop="'Current MP'"
                  :for-verra-or-auditor-reports="true"
                  @filterHandle="filterHandle"
                  @buttonOpenClose="buttonOpenClosehandle"
                />
              </div>
            </el-col>
            <el-col
              class="p-0"
              :span="filterButtonOpenClose || $vuetify.display.width < 450 ? 24 : 16"
              :class="
                $vuetify.display.width < 450
                  ? 'pr-1 order-1 width-100-p d-flex x-end'
                  : 'd-flex justify-content-end'
              "
            >
              <div class="d-flex justify-content-end verra-report-button-wrapper m-r-10">
                <el-button
                  color="#ddf0ac"
                  class="height-40 border-color-light mr-1 rounded-3"
                  @click="handleClearCache"
                >
                  <svg class="stroke-icon width-20 height-20">
                    <use href="@/assets/svg/icon-sprite.svg#stroke-refresh"></use>
                  </svg>
                  <span class="moderat-btn-apply pl-3"> Refresh Cache </span>
                </el-button>

                <el-button
                  class="new-download-file-btn new-button-behavior"
                  @click.stop="handleExportFile"
                >
                  <svg class="width-40 height-40">
                    <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                  </svg>
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <el-row
        v-loading="verraPageLoading"
        class="m-0 width-100-p"
        :class="
          $vuetify.display.width >= 1400
            ? 'mb-30'
            : $vuetify.display.width >= 768
              ? 'mb-30'
              : $vuetify.display.width >= 375
                ? 'mb-24'
                : 'mb-20'
        "
      >
        <el-col class="d-flex align-item-center" :span="24">
          <div class="row m-0 width-100-p">
            <div>
              <verraReportTables
                ref="childComp"
                :parent-data-filter="filter"
                :table-data="tableData"
                :pending-by-report="pendingByReport"
                :total-row-prop="total_items"
                @tableAction="handleTableAction"
              />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import verraReportTables from "./verraReportTables.vue";
import FilterS2 from "../common/filter-s2.vue";
import { exportMultipleDataLists } from "../common/exportExcel";
import userService from "@/services/user.service";
import {
  fetchEqReports,
  refreshEqCache,
  collectTaskIdsFromBundle,
  pollTaskIdsUntilSettled,
  VERRA_EQ_REPORT_NAMES,
} from "@/services/eqReportsApi";
import { createLoadingInstance } from "../common/common-tools";
import { ElMessageBox } from "element-plus";
import { useToast } from "vue-toastification";
import {
  addTaskIdtoSessionStorage,
  removeTaskFromSessionStorage,
} from "../common/pollingCeleryTask";

/** Persist bundle Celery ids across navigation (custom range / no cache). */
const SS_VERERRA_BUNDLE_POLL = "verraReportsEqBundlePoll";
/** Persist cache-refresh batch task across navigation. */
const SS_VERERRA_CACHE_REFRESH = "verraReportsCacheRefresh";

/** Polling for POST cache refresh only: 1 min interval, max 100 bulk rounds. */
const CACHE_REFRESH_CELERY_POLL_OPTS = {
  intervalMs: 60000,
  maxRounds: 100,
  timeoutMs: 101 * 60 * 1000 + 120000,
};

export default {

  components: {
    verraReportTables,
    FilterS2,
  },
  data() {
    return {
      filterButtonOpenClose: false,

      filter: {
        startDate: null,
        endDate: null,
        search: null,
        mp_id: null,
      },

      tableData: {
        project_instance: [],
        verra_eq1: { result: [], updated_at: "" },
        verra_eq4: { result: [], updated_at: "" },
        verra_eq5: { result: [], updated_at: "" },
        verra_eq7: { result: [], updated_at: "" },
        verra_eq9: { result: [], updated_at: "" },
      },

      pendingByReport: {
        verra_eq1: false,
        verra_eq4: false,
        verra_eq5: false,
        verra_eq7: false,
        verra_eq9: false,
      },

      total_items: 100,

      verraPageLoading: false,
      verraCacheRefreshInProgress: false,
    };
  },

  mounted() {
    this.$nextTick(async () => {
      this.tryResumeVerraCacheRefreshPoll();
      await this.tryResumeVerraBundlePollFromStorage();
    });
  },

  methods: {
    emptyEqShell() {
      return { result: [], updated_at: "" };
    },

    resetPendingByReport() {
      VERRA_EQ_REPORT_NAMES.forEach((k) => {
        this.pendingByReport[k] = false;
      });
    },

    clearVerraBundlePollState() {
      try {
        sessionStorage.removeItem(SS_VERERRA_BUNDLE_POLL);
      } catch (e) {
        /* ignore */
      }
    },

    saveVerraBundlePollState(params, mpDatesOnly, taskIds, taskIdToReport) {
      try {
        sessionStorage.setItem(
          SS_VERERRA_BUNDLE_POLL,
          JSON.stringify({
            params: {
              mp_id: params.mp_id,
              start_date: params.start_date ?? null,
              end_date: params.end_date ?? null,
            },
            paramsMode: mpDatesOnly ? "mp_cache" : "custom",
            taskIds,
            taskIdToReport: taskIdToReport || {},
          }),
        );
      } catch (e) {
        console.warn("saveVerraBundlePollState:", e);
      }
    },

    readVerraBundlePollState() {
      try {
        const raw = sessionStorage.getItem(SS_VERERRA_BUNDLE_POLL);
        return raw ? JSON.parse(raw) : null;
      } catch {
        return null;
      }
    },

    bundlePollMatchesCurrentFilter(st, mpDatesOnly) {
      if (!st?.params || !this.filter?.mp_id) {
        return false;
      }
      if (Boolean(mpDatesOnly) !== (st.paramsMode === "mp_cache")) {
        return false;
      }
      if (
        Number(st.params.mp_id) !== Number(this.filter.mp_id)
      ) {
        return false;
      }
      if (!mpDatesOnly) {
        const cur = this.verraEqParams(mpDatesOnly);
        if (
          String(st.params.start_date || "") !== String(cur.start_date || "") ||
          String(st.params.end_date || "") !== String(cur.end_date || "")
        ) {
          return false;
        }
      }
      return true;
    },

    /** Resume custom-range Celery bundle after navigation (no second bundled GET). */
    async tryResumeVerraBundlePollFromStorage() {
      const st = this.readVerraBundlePollState();
      if (!st || !Array.isArray(st.taskIds) || st.taskIds.length === 0) {
        return false;
      }
      const mpDatesOnly = st.paramsMode === "mp_cache";
      if (!this.bundlePollMatchesCurrentFilter(st, mpDatesOnly)) {
        this.clearVerraBundlePollState();
        return false;
      }

      VERRA_EQ_REPORT_NAMES.forEach((name) => {
        this.pendingByReport[name] = true;
      });

      this.$store.dispatch("tasksProcessing/startLoading", {
        itemKey: "verra_reports",
        taskId: st.taskIds[0],
        taskType: "reports",
        status: "PENDING",
      });

      const poll = await pollTaskIdsUntilSettled(st.taskIds, {
        intervalMs: 3000,
        timeoutMs: 900000,
      });
      this.clearVerraBundlePollState();

      if (!poll.ok) {
        this.$store.dispatch("tasksProcessing/failTask", "verra_reports");
        return false;
      }

      this.applyVerraTablesFromCeleryPollStatuses(poll.statuses || [], st.taskIdToReport || {});
      this.$store.dispatch("tasksProcessing/completeTask", "verra_reports");
      return true;
    },

    clearVerraCacheRefreshState() {
      try {
        sessionStorage.removeItem(SS_VERERRA_CACHE_REFRESH);
      } catch (e) {
        /* ignore */
      }
    },

    runVerraCacheRefreshFollowUp(taskId) {
      if (!taskId || this.verraCacheRefreshInProgress) {
        return;
      }
      this.verraCacheRefreshInProgress = true;
      pollTaskIdsUntilSettled([taskId], CACHE_REFRESH_CELERY_POLL_OPTS)
        .then((poll) => {
          this.clearVerraCacheRefreshState();
          try {
            removeTaskFromSessionStorage(taskId);
          } catch (e) {
            /* ignore */
          }
          if (poll.ok) {
            this.$store.dispatch("tasksProcessing/completeTask", "verra_reports");
            useToast().success(
              "Verra cache refresh finished. Loading latest monitoring-period data.",
              {
                icon: "fa fa-check",
                position: "bottom-right",
                timeout: 6000,
              },
            );
            if (this.$route?.name === "Dashboard-Verra-Reports") {
              this.fetchVerraReports({ mpDatesOnly: true });
            }
          } else {
            this.$store.dispatch("tasksProcessing/failTask", "verra_reports");
            const hitMaxRounds = (poll.statuses || []).some((s) => s?.result === "max_rounds");
            useToast().error(
              hitMaxRounds
                ? "Verra cache refresh was still running after 100 checks (about 100 minutes). Try again later."
                : poll.timeout
                  ? "Verra cache refresh timed out."
                  : "Verra cache refresh failed.",
              {
                icon: "fa fa-times",
                position: "bottom-right",
                timeout: 6000,
              },
            );
          }
        })
        .catch((e) => {
          console.error("Verra cache refresh poll:", e);
          this.clearVerraCacheRefreshState();
          this.$store.dispatch("tasksProcessing/failTask", "verra_reports");
        })
        .finally(() => {
          this.verraCacheRefreshInProgress = false;
        });
    },

    tryResumeVerraCacheRefreshPoll() {
      if (!this.filter?.mp_id) {
        return;
      }
      let st;
      try {
        const raw = sessionStorage.getItem(SS_VERERRA_CACHE_REFRESH);
        if (!raw) {
          return;
        }
        st = JSON.parse(raw);
      } catch {
        this.clearVerraCacheRefreshState();
        return;
      }
      if (!st?.taskId) {
        return;
      }
      if (
        Number(st.mp_id) !== Number(this.filter.mp_id)
      ) {
        return;
      }
      this.$store.dispatch("tasksProcessing/startLoading", {
        itemKey: "verra_reports",
        taskId: st.taskId,
        taskType: "reports",
        status: "PENDING",
      });
      this.runVerraCacheRefreshFollowUp(st.taskId);
    },

    applyVerraBundlePayload(payload) {
      this.resetPendingByReport();
      const rows = Array.isArray(payload?.reports) ? payload.reports : [];
      const byName = Object.fromEntries(rows.map((r) => [r.report_name, r]));

      VERRA_EQ_REPORT_NAMES.forEach((name) => {
        const row = byName[name];
        if (!row) {
          this.tableData[name] = this.emptyEqShell();
          return;
        }
        if (String(row.status).toUpperCase() === "PENDING") {
          this.pendingByReport[name] = true;
          const d = row.data && typeof row.data === "object" ? row.data : {};
          this.tableData[name] = {
            result: Array.isArray(d.result) ? d.result : [],
            updated_at: d.updated_at || "",
          };
          return;
        }
        if (String(row.status).toUpperCase() === "SUCCESS") {
          const d = row.data && typeof row.data === "object" ? row.data : {};
          let result = d.result;
          if (!Array.isArray(result)) {
            result = result == null ? [] : [result];
          }
          this.tableData[name] = {
            result,
            updated_at: d.updated_at || "",
          };
          return;
        }
        this.tableData[name] = this.emptyEqShell();
      });
    },

    /** @returns {Record<string, string>} task_id -> report_name for Celery poll hydration */
    buildTaskIdToReportNameFromBundle(payload) {
      const map = {};
      const reports = payload?.reports || [];
      for (const r of reports) {
        if (r?.task_id && r?.report_name) {
          map[r.task_id] = r.report_name;
        }
      }
      const topIds = Array.isArray(payload?.task_ids) ? payload.task_ids : [];
      if (Object.keys(map).length === 0 && topIds.length > 0 && reports.length > 0) {
        topIds.forEach((id, i) => {
          const r = reports[i];
          if (id && r?.report_name) {
            map[id] = r.report_name;
          }
        });
      }
      return map;
    },

    /**
     * After a single bundled GET + Celery polling, merge GET /api/celery/task/… results
     * into tableData (custom range / no cache path).
     */
    applyVerraTablesFromCeleryPollStatuses(statuses, taskIdToReport) {
      const map = taskIdToReport || {};
      const extract = (raw) => {
        if (raw == null || raw === "hasResult") {
          return null;
        }
        if (Array.isArray(raw)) {
          return { result: raw, updated_at: "" };
        }
        if (typeof raw === "object") {
          if (Array.isArray(raw.result)) {
            return { result: raw.result, updated_at: raw.updated_at || "" };
          }
          const d = raw.data;
          if (d && typeof d === "object" && Array.isArray(d.result)) {
            return { result: d.result, updated_at: d.updated_at || "" };
          }
        }
        return null;
      };

      for (const s of statuses || []) {
        const tid = s?.task_id;
        const reportName = map[tid];
        if (!reportName || !VERRA_EQ_REPORT_NAMES.includes(reportName)) {
          continue;
        }
        const extracted = extract(s?.result);
        if (!extracted) {
          continue;
        }
        this.tableData[reportName] = extracted;
        this.pendingByReport[reportName] = false;
      }
      VERRA_EQ_REPORT_NAMES.forEach((name) => {
        this.pendingByReport[name] = false;
      });
    },

    verraEqParams(mpDatesOnly) {
      const params = {
        mp_id: this.filter.mp_id,
      };
      const useCustomRange =
        !mpDatesOnly &&
        this.filter.hasCustomDate === true &&
        this.filter.startDate &&
        this.filter.endDate;
      if (useCustomRange) {
        params.start_date = this.filter.startDate;
        params.end_date = this.filter.endDate;
      }
      return params;
    },

    filterHandle(event) {
      this.filter = event;
      this.fetchVerraReports();
    },

    buttonOpenClosehandle(event) {
      this.filterButtonOpenClose = event;
    },

    async fetchVerraReports(options = {}) {
      const mpDatesOnly = options.mpDatesOnly === true;

      this.$store.dispatch("tasksProcessing/clearLoadingState", "verra_reports");

      if (!this.filter.mp_id) {
        return;
      }

      const projectInstanceRequest = {
        search: null,
        current_page: null,
        perPageCount: null,
      };

      try {
        const projectInstanceResponse = await userService.getProjectInstance(
          projectInstanceRequest,
          null,
          1,
          50,
          true,
        );
        if (!projectInstanceResponse.data || !projectInstanceResponse.data.project_instance) {
          console.log("error when fetching project instance");
        }
        this.tableData.project_instance = projectInstanceResponse.data.project_instance || [];
      } catch (error) {
        console.error("Error fetching project instance:", error.message);
      }

      const params = this.verraEqParams(mpDatesOnly);

      try {
        this.verraPageLoading = false;
        if (await this.tryResumeVerraBundlePollFromStorage()) {
          return;
        }

        this.verraPageLoading = true;
        let payload;
        try {
          payload = await fetchEqReports("verra", params);
        } catch (error) {
          const msg =
            error?.response?.data?.message ||
            error?.message ||
            "Failed to load Verra equation reports.";
          console.error("Error fetching bundled verra reports:", error);
          await ElMessageBox.alert(
            `<span class="moderat-meRed">${msg}</span>`,
            "Error",
            { confirmButtonText: "OK", dangerouslyUseHTMLString: true },
          ).catch(() => {});
          return;
        }

        this.applyVerraBundlePayload(payload);
        const taskIds = collectTaskIdsFromBundle(payload);

        if (taskIds.length === 0) {
          return;
        }

        this.verraPageLoading = false;

        this.saveVerraBundlePollState(params, mpDatesOnly, taskIds, this.buildTaskIdToReportNameFromBundle(payload));

        this.$store.dispatch("tasksProcessing/startLoading", {
          itemKey: "verra_reports",
          taskId: taskIds[0],
          taskType: "reports",
          status: "PENDING",
        });

        const poll = await pollTaskIdsUntilSettled(taskIds, {
          intervalMs: 3000,
          timeoutMs: 900000,
        });

        this.clearVerraBundlePollState();

        if (!poll.ok) {
          const detail = poll.timeout ? "Timed out waiting for reports." : "One or more tasks failed.";
          console.error("Verra report task polling:", detail, poll);
          this.$store.dispatch("tasksProcessing/failTask", "verra_reports");
          await ElMessageBox.alert(
            `<span class="moderat-meRed">${detail}</span>`,
            "Reports",
            { confirmButtonText: "OK", dangerouslyUseHTMLString: true },
          ).catch(() => {});
          return;
        }

        const taskIdToReport = this.buildTaskIdToReportNameFromBundle(payload);
        this.applyVerraTablesFromCeleryPollStatuses(poll.statuses || [], taskIdToReport);
        this.$store.dispatch("tasksProcessing/completeTask", "verra_reports");
      } finally {
        this.verraPageLoading = false;
      }
    },

    unwrapVerraRows(val) {
      if (val && typeof val === "object" && Array.isArray(val.result)) {
        return val.result;
      }
      if (Array.isArray(val)) {
        return val;
      }
      return [];
    },

    async handleExportFile() {
      const loading = createLoadingInstance();

      try {
        const dataToExport = {
          project_instance: Array.isArray(this.tableData.project_instance)
            ? this.tableData.project_instance
            : [],
          verra_eq1: this.unwrapVerraRows(this.tableData.verra_eq1),
          verra_eq4: this.unwrapVerraRows(this.tableData.verra_eq4),
          verra_eq5: this.unwrapVerraRows(this.tableData.verra_eq5),
          verra_eq7: this.unwrapVerraRows(this.tableData.verra_eq7),
          verra_eq9: this.unwrapVerraRows(this.tableData.verra_eq9),
        };

        const hasData = Object.values(dataToExport).some(
          (table) => Array.isArray(table) && table.length > 0,
        );
        if (!hasData) {
          console.log("No data available for any report type.");
          loading.close();
          return;
        }

        const tableNames = {
          verra_eq1: "Verra eq1",
          verra_eq4: "Verra eq4",
          verra_eq5: "Verra eq5",
          verra_eq7: "Verra eq7",
          verra_eq9: "Verra eq9",
          project_instance: "Project Instance",
        };

        const skipKeysList = {
          verra_eq1: [],
          verra_eq4: [],
          verra_eq5: [],
          verra_eq7: [],
          verra_eq9: [],
          project_instance: [],
        };

        try {
          await exportMultipleDataLists({
            title: "Verra Report",
            tableData: dataToExport,
            tableNames,
            skipKeysList,
            fileName: "VerraReport.xlsx",
          });
          loading.close();
          console.log("Excel file generated successfully!");
        } catch (error) {
          loading.close();
          console.error("Error generating Excel file:", error.message);
        }
      } catch (error) {
        loading.close();
        console.error("Error exporting file:", error.message);
      }
    },

    async handleClearCache() {
      this.tableData.project_instance = [];
      this.tableData.verra_eq1 = this.emptyEqShell();
      this.tableData.verra_eq4 = this.emptyEqShell();
      this.tableData.verra_eq5 = this.emptyEqShell();
      this.tableData.verra_eq7 = this.emptyEqShell();
      this.tableData.verra_eq9 = this.emptyEqShell();
      this.resetPendingByReport();

      if (!this.filter.mp_id) {
        await ElMessageBox.alert(
          `<span class="moderat-meRed">Select a monitoring period and project first.</span>`,
          "Refresh cache",
          { confirmButtonText: "OK", dangerouslyUseHTMLString: true },
        ).catch(() => {});
        return;
      }

      try {
        const body = { mp_id: this.filter.mp_id};
        const data = await refreshEqCache("verra", body);
        const taskId = data.task_id;

        if (taskId) {
          try {
            sessionStorage.setItem(
              SS_VERERRA_CACHE_REFRESH,
              JSON.stringify({
                taskId,
                mp_id: this.filter.mp_id,
              }),
            );
          } catch (e) {
            console.warn("cache refresh sessionStorage:", e);
          }

          addTaskIdtoSessionStorage("verra_reports", taskId, "PENDING", "message", {
            success_message: "Verra equation cache refresh finished.",
            error_message: "Verra equation cache refresh failed.",
          });

          this.runVerraCacheRefreshFollowUp(taskId);
        } else {
          await this.fetchVerraReports({ mpDatesOnly: true });
          await ElMessageBox.alert(
            `<span class="moderat-meGreen">Cache refresh completed. Showing cached monitoring-period data.</span><br/>`,
            "Refresh cache",
            { confirmButtonText: "OK", type: "success", dangerouslyUseHTMLString: true },
          ).catch(() => {});
        }
      } catch (error) {
        const msg = error?.response?.data?.message || error?.message || "Cache refresh failed.";
        console.error("Error clearing cache:", error);
        await ElMessageBox.alert(
          `<span class="moderat-meRed">${msg}</span>`,
          "Refresh cache",
          { confirmButtonText: "OK", dangerouslyUseHTMLString: true },
        ).catch(() => {});
      }
    },

    handleTableAction() {},
  },
};
</script>